__turbopack_context__.v({
  "btn": "NewsletterSubscription-module-scss-module__h2xeyW__btn",
  "btnWrapper": "NewsletterSubscription-module-scss-module__h2xeyW__btnWrapper",
  "content": "NewsletterSubscription-module-scss-module__h2xeyW__content",
  "contentHeader": "NewsletterSubscription-module-scss-module__h2xeyW__contentHeader",
  "contentText": "NewsletterSubscription-module-scss-module__h2xeyW__contentText",
  "contentTextWrapper": "NewsletterSubscription-module-scss-module__h2xeyW__contentTextWrapper",
  "contentTitle": "NewsletterSubscription-module-scss-module__h2xeyW__contentTitle",
  "imgWrapper": "NewsletterSubscription-module-scss-module__h2xeyW__imgWrapper",
  "scrollToBar": "NewsletterSubscription-module-scss-module__h2xeyW__scrollToBar",
  "title": "NewsletterSubscription-module-scss-module__h2xeyW__title",
  "wrapper": "NewsletterSubscription-module-scss-module__h2xeyW__wrapper",
});
